export default __webpack_public_path__ + "static/media/hub-messaging.472a76de.jpg";